import { userService } from './../../../Services/userService';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { restURL } from '../../../Models/restURL';
import { motorProposalService } from '../../../Services/motorProposalService';
import { ProposalModel } from '../../../Models/ProposalModel'
import { proposalResMdl } from '../../../Models/proposalResMdl'
import { RegModel } from '../../../Models/RegModel';
import { FortPaymentReq } from '../../../Models/FortPaymentReq';
import { FortCheckReqMdl, TransStatusMdl } from '../../../Models/FortCheckReqMdl';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';

@Component({
  selector: 'PayfortStatus',
  templateUrl: './PayfortStatus.html',
  styleUrls: ['./PayfortStatus.css']
})
export class PayfortStatus {

  public isShowLoading: boolean = false;


  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public fortReq: FortPaymentReq = new FortPaymentReq();
  public fortStatus: TransStatusMdl = new TransStatusMdl();
  public fortCheckReq: FortCheckReqMdl = new FortCheckReqMdl();
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();

  constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private userinfo: userService) {
    //this.fortReq = JSON.parse(sessionStorage.getItem("fortObj"));
    if (sessionStorage.getItem("fortObj") != null) {
      this.fortReq = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("fortObj")));
    }


    this.getPaymentStatus();

    //alert(JSON.stringify(this.paymentReq));

  }


  getPaymentStatus() {
    this.isShowLoading = true;


    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.fortReq));
    //this.http.post<TransStatusMdl>(this.url.baseURL + "/Payfort/savePaymentCheckReq", this.fortReq, this.userinfo.getHttpOptions())
    this.http.post<TransStatusMdl>(this.url.baseURL + "/Payfort/savePaymentCheckReq", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise().then((result) => {
        this.fortStatus = result;
        //alert(JSON.stringify(this.fortStatus));
        this.isShowLoading = false;


      },
        (error) => {
          this.isShowLoading = false;
          alert("Invalid!,Please try again later");
        });

  }


  Redirect() {
    this.router.navigate(['/NewDashboard/Policy']);
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Payfort/PayfortStatus/PayfortStatus.ts